type OperatingSystem = 'ios' | 'android' | 'desktop' | 'unknown'

export const getOperatingSystem = (): OperatingSystem => {
  try {
    const userAgent = navigator.userAgent || navigator.vendor
    // Check for iOS
    if (/iPad|iPhone|iPod/.test(userAgent) && !('MSStream' in window)) {
      return 'ios'
    }

    // Check for Android
    if (/android/i.test(userAgent)) {
      return 'android'
    }

    // Check for Desktop
    if (!/Mobile|Tablet|Android|iPad|iPhone|iPod/.test(userAgent)) {
      return 'desktop'
    }

    // Default to unknown
    return 'unknown'
  } catch (_) {
    return 'unknown'
  }
}
